/** @jsx jsx */
import { useContext } from 'react';
import { jsx } from '@emotion/core';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ProductsDetailsList } from 'components/ProductsDetailsList';
import { CHALLENGE_PHASE } from 'constants/challenges';
import { ChallengeSection, ChallengeDeclareButton } from 'components';
import { ChallengeListDetailsContext } from '..';
import * as S from './styles';
import { TProductDetails } from 'interfaces/challenge.types';
import { productDetailsListDataFormatter } from './utils';
import { productCurrencySelector } from 'reducers/app.reducer';
import { getResultUnit } from 'utils';

export default function ResultPerProductSection() {
  const { t } = useTranslation();
  const { challenge, challengeResult, currentPhase } = useContext(
    ChallengeListDetailsContext,
  );
  const rewardUnit = useSelector(productCurrencySelector);
  const resultUnit = getResultUnit(challenge);
  const unitToDisplay = challenge?.isRewardingGlobal ? resultUnit : rewardUnit;

  const challengeResultsByProduct =
    challenge?.challengeResults?.[0]?.challengeResultsByProduct;
  const challengeProducts = challenge?.challengeListProducts;
  let productDetailsList: TProductDetails[] = [];
  if (challengeProducts && challengeResultsByProduct) {
    productDetailsList = productDetailsListDataFormatter(
      challengeProducts,
      challengeResultsByProduct,
    );
  }

  const isGoalMecanicByProduct = !challenge?.isRewardingGlobal;

  const hasResult =
    !!challengeResult ||
    !!challenge.currentChallengeMetaData?.lastValidatedDeclarationDate;
  const canDeclare =
    currentPhase === CHALLENGE_PHASE.DURING_CHALLENGE &&
    challenge.isDeclarationMultiple;

  return (
    <ChallengeSection
      defaultExpanded={hasResult}
      title={
        <strong>{t('challenges.detail.results.title_per_product')}</strong>
      }
    >
      {hasResult ? (
        <S.Section>
          <ProductsDetailsList
            productDetailsList={productDetailsList}
            rowsPerPage={10}
            isGoalMecanicByProduct={isGoalMecanicByProduct}
            displayFinancialValues={challenge?.needCurrencyValue}
            displayGainValues
            unitToDisplay={unitToDisplay}
            withHeaderFieldsDescription
          />
          <S.DeclareButtonContainer>
            <ChallengeDeclareButton
              challenge={challenge}
              title={
                canDeclare
                  ? t('challenges.detail.declare.declareOtherResults')
                  : t('challenges.detail.description.alreadyDeclared')
              }
            />
          </S.DeclareButtonContainer>
        </S.Section>
      ) : (
        <Typography>{t('challenges.no_result')}</Typography>
      )}
    </ChallengeSection>
  );
}
